export const getInitialStateGoals = () => ({
    goalsPt: [],
    goalsEn: [],
});